import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const INITIAL_SECONDS = 20 * 60; // 20 minutes
export function StickyBar() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? INITIAL_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const display = `${pad(minutes)}:${pad(seconds)}`;
  return <div className="fixed top-0 left-0 right-0 text-white py-2.5 px-4 text-center z-50 shadow-md bg-[#9B1B30]" data-id="element-208">
      <p className="text-[13px] md:text-base font-semibold tracking-wide" data-id="element-209">
        🔥 <span className="font-bold" data-id="element-210">50% OFF</span> termina en{' '}
        <motion.span key={display} initial={{
        scale: 1.08,
        opacity: 0.8
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 22
      }} className="inline-block font-mono font-bold tabular-nums" data-id="element-211">
          {display}
        </motion.span>
      </p>
    </div>;
}